module.exports = __webpack_public_path__ + "static/Jan Szczepkowski przy stole kreślarskim (1936r.) NAC-714e2e39794fd707d76b53b27896422b.jpg";